import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import { cn } from './lib/cn';

type PhotoData = {
    id: number;
    originalURL: string;
    thumbnailURL: string;
};

type PhotoGridProps = {
    photos: PhotoData[];
    className?: string;
};

export function PhotoGrid({ photos, className }: PhotoGridProps) {
    return (
        <div className={cn('grid grid-cols-2 gap-1 desktop:grid-cols-3', className)}>
            <PhotoProvider>
                {photos.map(photo => (
                    <div key={photo.id} className='relative overflow-hidden rounded-sm shadow-sm'>
                        <PhotoView key={photo.id} src={photo.originalURL}>
                            <img src={photo.thumbnailURL} style={{ objectFit: 'cover' }} className='cursor-pointer' />
                        </PhotoView>
                    </div>
                ))}
            </PhotoProvider>
        </div>
    );
}
